// @flow
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { colors } from '../../shared/styles';
import Scrollable from '../../components/shared/Scrollable';

const StyledNav = styled.div`
    position: relative;
    flex: 0 0 200px;
    background: ${colors.grey.dark};
    color: ${colors.white};

    & .menu {
        height: calc(100vh - 108px);
    }

    & ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

    & li {
        display: block;
        border-bottom: solid 1px ${colors.grey.default};
    }

    & li a {
        display: block;
        padding: 20px 30px;
        background: ${colors.grey.dark};
        color: ${colors.white};
        text-decoration: none;
    }

    & li {
        & a:focus {
            opacity: 1;
        }
    }

    & li a.active {
        color: ${colors.white};
        background: ${colors.grey.default};
    }

    & li.sub {
        border-bottom: none;

        a {
            padding: 20px 30px;
        }

        & ul li a {
            padding: 10px 20px 20px 40px;
            font-size: 13px;
            color: ${colors.darkBlue.default};
        }

        & ul li a.active {
            color: ${colors.white};
        }
    }

    & .logout {
        position: absolute;
        bottom: 0;
        width: calc(100% - 40px);
        padding: 0 20px 20px 20px;
        margin: 0;
        background: ${colors.grey.dark};
        color: ${colors.white};
        text-decoration: none;
        border: none;
        text-align: center;
        font-size: 14px;
    }

    & .logout button {
        background: ${colors.orange.default};
        color: ${colors.white};
        border: none;
        border-radius: 4px;
        text-align: center;
        text-decoration: none;
        padding: 12px 24px;
        font-size: 14px;
        white-space: nowrap;
        cursor: pointer;
        width: 100%;
    }
`;

const Nav = (props: {
    forenames: string,
    role: string,
    onLogout: Function,
}) => {
    const { forenames, role, onLogout } = props;

    return (
        <StyledNav>
            <Scrollable additionalClassName="menu">
                {role === 'property_manager' &&
                    <ul>
                        <li>
                            <NavLink to="/property" activeClassName="active">
                                Property Search
                            </NavLink>
                        </li>
                        <li className="sub">
                            <NavLink to="/contacts" activeClassName="active">
                                Contacts
                            </NavLink>
                            <ul>
                                <li>
                                    <NavLink
                                        to="/contacts/reassigns"
                                        activeClassName="active"
                                    >
                                        Reassign Contacts
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <NavLink to="/stations" activeClassName="active">
                                Stations
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/standard-text"
                                activeClassName="active"
                            >
                                Standard Text
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/to-let-boards"
                                activeClassName="active"
                            >
                                To Let Boards
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/plasma-screens"
                                activeClassName="active"
                            >
                                Plasma Screens
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/contact-requests"
                                activeClassName="active"
                            >
                                Contact Requests
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/export" activeClassName="active">
                                Export
                            </NavLink>
                        </li>
                    </ul>}

                {role === 'to_let_boards' &&
                    <ul>
                        <li>
                            <NavLink
                                to="/to-let-boards"
                                activeClassName="active"
                            >
                                To Let Boards
                            </NavLink>
                        </li>
                    </ul>}
            </Scrollable>

            <div className="logout">
                <p>
                    Welcome back, {forenames}
                </p>
                <button onClick={onLogout}>Logout</button>
            </div>
        </StyledNav>
    );
};

export default Nav;



// WEBPACK FOOTER //
// ./src/components/shared/Nav.js